module.exports = __webpack_public_path__ + "static/media/SPONSORS (6).3347e5bc.png";